import { FC } from "react";
import { closeRightPanel } from "../../../app/chat/chatSlice";
import { useAppDispatch } from "../../../app/hooks";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";
import clsx from "clsx";

interface IProps {
    title: string,
    visible: boolean,
    hideOptions?: boolean,
}
const RightPanel: FC<IProps> = ({ title, visible, hideOptions, children }) => {
    const dispatch = useAppDispatch();
    const closeButtonHandler = () => {
        dispatch(closeRightPanel());
    };
    return (
        visible ?
            <div className={clsx(!hideOptions && "w-80",
                "flex flex-col bg-gray-100 h-full z-10",
                "xxsToXs:absolute xxsToXs:w-full xsToSm:w-full xsToSm:absolute")}>
                <div className="flex-none message-header px-5 rounded-tr-lg h-[60px] flex items-center justify-between">
                    <div className="text-md font-medium -mb-[4px] text-gray-700">{title}</div>
                    {!hideOptions &&
                        <button className="rounded-full hover:bg-white hover:text-blue-500 text-white" onClick={closeButtonHandler}>
                            <CloseIcon className="w-[15px] h-[15px] text-gray-400" />
                        </button>
                    }
                </div>
                {children}
            </div> : <></>
    );
};

export default RightPanel;
